export interface PostKeys {
    code?: string;
    accessToken?: string;
    frontendFlag: number;
    localHostUrl?: string;
    token?: string;
    groupIdentifier?: string;
}

export interface PostSignUp {
    email?: string;
    names?: string;
    phone?: string;
    'g-recaptcha-response'?: string;
    token?: string;
    groupIdentifier?: string;
    investigationIdentifier?: string;
}

export interface OAuthState {
    action?: string;
    token?: string;
    groupIdentifier?: string;
    studyIdentifier?: string;
    studyTitle?: string;
    caseIdentifier?: string;
    formIdentifier?: string;
    entryIdentifier?: string;
    mode?: string;
    redirectUrl?: string;
    autoRedirect?: string;
    lang?: string;
    next?: string;
}

export interface NetworkKeys {
    data?: string;
    uri?: string;
    user?: string;
    unscrambledUser?: string;
    email?: string;
    requiresOnboarding?: boolean;
    oauthAccessToken?: string;
}

interface IKeys {
    data?: string;
    key?: string;
    userId?: string;
    email?: string;
    requiresOnboarding?: boolean;
    oauthAccessToken?: string;
}

export class Keys {
  data?: string;
  key?: string;
  identifier?: string;
  email?: string;
  requiresOnboarding?: boolean;

  oauthAccessToken?: string;
  avatar?: string;
  name?: string;

  constructor(keys: IKeys) {
    this.data = keys.data;
    this.key = keys.key;
    this.identifier = keys.userId;
    this.email = keys.email;
    this.requiresOnboarding = keys.requiresOnboarding;
    this.oauthAccessToken = keys.oauthAccessToken;
  }

  static mapKeys(networkKeys: NetworkKeys) {
    return new Keys({
      data: networkKeys.data,
      key: networkKeys.uri?.split('/')?.pop() ?? '',
      userId: networkKeys.user?.split('/')?.pop() ?? '',
      email: networkKeys.email,
      requiresOnboarding: networkKeys.requiresOnboarding,
      oauthAccessToken: networkKeys.oauthAccessToken
    });
  }
}
